import { render, staticRenderFns } from "./FormVideos.vue?vue&type=template&id=1845f8b9&"
import script from "./FormVideos.vue?vue&type=script&lang=js&"
export * from "./FormVideos.vue?vue&type=script&lang=js&"
import style0 from "./FormVideos.vue?vue&type=style&index=0&id=1845f8b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports